import V1 from '../../constants/v1-api-constant';
import apiClient from "../../gateway/api-gateway";

async function getPublishCount(): Promise<any> {
    const response = await apiClient.get(V1.publishedCount);
    return response?.data?.data;
}

const PublishCountService = {
    getPublishCount,
};
export default PublishCountService;